import { profileClient } from "../../api/clients";
import { ListUsersResponse } from "../interfaces/ListUsersResponse";
import { ReportGenUser } from "../interfaces/User";

export async function fetchUsers(
  organizationId: string,
  includeInactive = false
): Promise<ReportGenUser[]> {
  const response = await profileClient.get<ListUsersResponse>(
    `/v1/stations/${organizationId}/users`,
    { params: { includeInactive } }
  );
  return response.data.users.map((user) => ({
    ...user,
    rank: user.metadata.position || "",
    badgeNumber: user.metadata.badge_number || "",
    station: user.metadata.station || "",
    status: user.membershipStatus,
    rmsUserId: user.metadata.rmsUserId || null,
    bodycamUserId: user.metadata.bodycamUserId || null,
    department: user.metadata.department || "",
  }));
}
